document.addEventListener("turbolinks:load", function() {
  $input = $('*[data-behavior="autocomplete"]')
  var options = {
    source: "/airports/search.json",
    change: function (event, ui) {
      if (ui.item == null) {
        this.value = '';
        alert('Please select a value from the list');
      }
    }
  };
  $input.autocomplete(options)
});